import { render } from "./inputModal.vue?vue&type=template&id=32479c7a&ts=true"
import script from "./inputModal.vue?vue&type=script&lang=ts"
export * from "./inputModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__